import React from "react";

import { Stack } from "@mui/system";

import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Switch from "@src/sharedComponents/Switch/Switch";
import FullDataTable from "@src/sharedComponents/Table/FullDataTable";
import { Cell } from "@src/sharedComponents/Table/Types";

import { FooterLoadingState } from "./Footer";
import { HeaderLoadingState } from "./Header";
import { DoNotSellColumns } from "./hooks/useDoNotSellTableData";

const LoadingState = () => {
  return (
    <>
      <HeaderLoadingState />
      <FullDataTable<DoNotSellColumns, Cell>
        noBorderRadius
        key={"details-loading"}
        useQueryParams={false}
        columns={["Security", "Account", "Quantity", "Value", "Do not sell"]}
        defaultSortColumn={["Security", "asc"]}
        rows={Array.from({ length: 10 }).map((_, idx) => ({
          key: idx.toString(),
          Security: {
            value: (
              <Stack direction="row" spacing={2} alignItems="center">
                <Skeleton height={20} width={60} />
                <Skeleton height={20} width={180} />
              </Stack>
            ),
          },
          Account: { value: <Skeleton height={20} /> },
          Quantity: { value: <Skeleton height={20} /> },
          Value: { value: <Skeleton height={20} /> },
          "Do not sell": {
            value: <Switch onClick={() => {}} on={false} disabled={true} />,
          },
        }))}
        emptyCell={<Switch onClick={() => {}} on={false} disabled={true} />}
        defaultRowsPerPage={10}
      />
      <FooterLoadingState />
    </>
  );
};

export default LoadingState;
